(function(){
  "use strict";

  function initAccordions(root){
    root.querySelectorAll('.psg-acc-head').forEach(function(h){
      h.addEventListener('click',function(){
        var item=h.parentElement;
        item.classList.toggle('open');
        var sym=h.querySelector('.sym');
        if(sym) sym.innerHTML = item.classList.contains('open') ? '&minus;' : '+';
      });
    });
  }

  function initReviewSlider(root){
    var el=root.querySelector('[data-psg-review-slider]');
    if(!el) return;
    var down=false,startX=0,startScroll=0,moved=false;
    el.addEventListener('pointerdown',function(e){ down=true; moved=false; startX=e.clientX; startScroll=el.scrollLeft; el.classList.add('dragging'); });
    window.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-startX;
      if(Math.abs(dx)>3) moved=true;
      el.scrollLeft=startScroll-dx;
    });
    window.addEventListener('pointerup',function(){ if(!down) return; down=false; el.classList.remove('dragging'); });
    el.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } },true);
  }

  function initLightbox(root){
    var box=root.querySelector('.psg-lightbox');
    if(!box) return;
    var img=box.querySelector('img');
    var imgs=Array.prototype.slice.call(root.querySelectorAll('[data-psg-zoom]'));
    imgs.forEach(function(el){ el.addEventListener('click',function(){ img.src=el.src; box.classList.add('open'); }); });
    box.querySelector('.close').addEventListener('click',function(){ box.classList.remove('open'); });
    box.addEventListener('click',function(e){ if(e.target===box) box.classList.remove('open'); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') box.classList.remove('open'); });
  }

  function initCountdown(root){
    var el=root.querySelector('[data-psg-countdown]');
    if(!el) return;
    var wrap=el.closest('.psg-countdown');
    var compareEl=wrap?wrap.querySelector('[data-psg-countdown-compare]'):null;
    var key='psgDeadline';
    var end=parseInt(localStorage.getItem(key)||'0',10);
    if(!end||end<Date.now()){ end=Date.now()+1000*60*60*8; localStorage.setItem(key,String(end)); }
    var ended=false;
    function revertPrice(){
      if(ended||!compareEl) return;
      ended=true;
      var comparePrice=compareEl.textContent;
      root.querySelectorAll('[data-psg-price-now]').forEach(function(p){ p.textContent=comparePrice; });
      root.querySelectorAll('[data-psg-price-was]').forEach(function(p){ p.style.display='none'; });
      if(wrap) wrap.textContent='Oferta finalizada \u2014 precio regular';
    }
    function tick(){
      var d=Math.max(0,end-Date.now());
      if(d<=0){ revertPrice(); return; }
      var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      function p(n){return n<10?'0'+n:''+n;}
      el.textContent=p(h)+':'+p(m)+':'+p(s);
    }
    tick(); setInterval(tick,1000);
  }

  function initPopup(root){
    var el=root.querySelector('[data-psg-popup]');
    if(!el) return;
    var country=root.getAttribute('data-psg-country')||'co';
    var buyersByCountry={
      co:[{name:'Andr\u00e9s',city:'Bogot\u00e1'},{name:'Camilo',city:'Medell\u00edn'},{name:'Diego',city:'Cali'},{name:'Jorge',city:'Barranquilla'},{name:'Felipe',city:'Bucaramanga'}],
      gt:[{name:'Carlos',city:'Ciudad de Guatemala'},{name:'Luis',city:'Quetzaltenango'},{name:'Marco',city:'Mixco'},{name:'Fernando',city:'Villa Nueva'},{name:'Jos\u00e9',city:'Antigua Guatemala'}]
    };
    var buyers=buyersByCountry[country]||buyersByCountry.co;
    var txtEl=el.querySelector('[data-psg-popup-text]');
    var closed=false,i=0;
    function show(){
      if(closed) return;
      var b=buyers[i%buyers.length];
      txtEl.innerHTML='<b>'+b.name+'</b> de '+b.city+' compr\u00f3 este kit hace '+(Math.floor(Math.random()*20)+2)+' minutos';
      el.classList.add('show'); i++;
      setTimeout(function(){ el.classList.remove('show'); },5000);
    }
    el.querySelector('[data-psg-popup-close]').addEventListener('click',function(){ closed=true; el.classList.remove('show'); });
    setTimeout(show,4000);
    setInterval(function(){ if(!el.classList.contains('show')) show(); },14000);
  }

  function init(){
    document.querySelectorAll('.psg[data-psg-root]').forEach(function(root){
      initAccordions(root);
      initReviewSlider(root);
      initCountdown(root);
      initPopup(root);
      initLightbox(root);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
